const module = "Temporal" in window ? await import("./temporal") : await import("./compatibility");

export function registerDefaultToday() {
  module.registerDefaultToday();

  // re-run on spa navigation
  document.addEventListener("spa.navigate", () => {
    module.registerDefaultToday();
  });
}
